import { render } from "./EditSubject.vue?vue&type=template&id=002bf951"
import script from "./EditSubject.vue?vue&type=script&lang=js"
export * from "./EditSubject.vue?vue&type=script&lang=js"

import "./EditSubject.vue?vue&type=style&index=0&id=002bf951&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__